module.exports = __webpack_public_path__ + "img/camion-citerne-bleu.b73d73d2.jpg";